import { Breadcrumb, PageHeader } from "antd";
import React, { useCallback, useContext, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { Routes } from "../../../Utils/Constants/routes";
import { RootContext } from "../../Root";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { translation } from "../../../i18n/translationConstant";
import { useTranslation } from "react-i18next";

interface CommonLayoutProps {
  imageUrl?: any;
  children: React.ReactNode;
  title?: any;
}

const CommonLayout: React.FC<CommonLayoutProps> = ({
  imageUrl,
  children,
  title,
}) => {
  const { push } = useHistory();
  const { location } = useHistory();
  const { setHeader }: any = useContext(RootContext);
  const { t } = useTranslation();
  const history = useHistory();

  const getTypeOfRoute: any = useMemo(() => {
    return {
      [Routes.termsandconditions]: "Terms & Conditions",
      [Routes.deleteAccount]: "Delete Account",
      [Routes.reportIssue]: "Report Issues",
      [Routes.userprofile]: "User Profile",
      [Routes.history]: "History",
      [Routes.changePassword]: "Reset PIN",
      [Routes.privacyandpolicy]: "Privacy & Policy",
      [Routes.grievanceredressal]: "Grievance Redressal",
    };
  }, []);

  const goBack = useCallback(() => {
    push(Routes.more);
  }, [push]);

  const goBack2 = () => {
    history.goBack();
  };

  useEffect(() => {
    setHeader(
      <Breadcrumb className="breadCrumbs" separator=">">
        <Breadcrumb.Item onClick={goBack2}>More</Breadcrumb.Item>
        <Breadcrumb.Item>
          {getTypeOfRoute["/" + location.pathname.split("/")[2]]}
        </Breadcrumb.Item>
      </Breadcrumb>
    );
    return () => {
      setHeader(null);
    };
  }, [goBack, setHeader, getTypeOfRoute, location.pathname]);
  return (
    <div className="userProfileRoot">
      {imageUrl ? (
        <div style={{ paddingLeft: "10px", width: "100%", paddingTop: "10px" }}>
          <PageHeader
            className="linkAccountTitle"
            backIcon={<ArrowLeftOutlined className="backIcon" onPointerOverCapture={undefined} onPointerMoveCapture={undefined}/>}
            onBack={goBack2}
            title={title}
          />
          <div className="row alignCenter justifyCenter">
            <img
              src={imageUrl}
              alt="My Profile"
              className="userProfileImage marginTop30"
            />
          </div>
        </div>
      ) : (
        <></>
      )}
      {children}
    </div>
  );
};

export default CommonLayout;
